import { FunctionComponent, useState } from "react";
import { useIntl } from "react-intl";
import HeaderMobileCart from "@Components/molecules/header/HeaderMobileCart";
import LoginModal from "@Components/molecules/LoginModal";
import Header from "@Components/organisms/Header";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import useCartContext from "@Hooks/useCartContext";
import cheerzLogo from "@Images/logo-cheerz.png";
import { Step } from "@Types/cart";
import { ScreenAction } from "@Types/login";
import "./style.scss";

interface Props {
  step: Step;
}

const HeaderCart: FunctionComponent<Props> = ({ step }) => {
  const { user } = useCartContext();
  const [action, setAction] = useState<ScreenAction>("signUp");
  const [displayLoginModal, setDisplayLoginModal] = useState<boolean>(false);
  const { isMediumScreen } = useBreakpoint();
  const intl = useIntl();

  const handleDisplayLoginModal = (action: ScreenAction) => {
    setAction(action);
    setDisplayLoginModal(true);
  };

  return (
    <div className="HeaderCart">
      {isMediumScreen ? (
        <HeaderMobileCart
          hideLoginBtn={step !== "checkout" || !user.isGuest}
          onClick={() => handleDisplayLoginModal(user.isGuest ? "signUp" : "signIn")}
        />
      ) : step === "checkout" ? (
        <Header userData={user} />
      ) : (
        <a className="HeaderCart-center" href={`/${intl.locale}/`}>
          <img alt="Cheerz" className="HeaderCart-image" src={cheerzLogo} />
        </a>
      )}
      <LoginModal
        action={action}
        display={displayLoginModal}
        hide={() => setDisplayLoginModal(false)}
      />
    </div>
  );
};

export default HeaderCart;
